<template>
    <div class="relative">
        <div class="absolute inset-s-4 inset-bs-0 w-px h-full bg-slate-300 lg:inset-s-12"></div>

        <group-collection-filter v-for="(filter, index) in filters"
            :key="filter.id"
            v-model="filters[index]"
            :filterIndex="index"
            :orgUnitId="props.orgUnitId"
            @remove="removeFilter(index)"
            :disabled="props.disabled"></group-collection-filter>

        <vx-box class="relative p-3 inline-flex space-x-2">
            <vx-button @click="add()"
                type="button"
                size="lg"
                color="primary"
                data-test="add">
                Add
                <font-awesome-icon widthAuto :icon="faCirclePlus"></font-awesome-icon>
            </vx-button>
        </vx-box>
    </div>
</template>

<script setup>
import { VxBox, VxButton } from '@voxie/frontend-components'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faCirclePlus } from '@fortawesome/pro-solid-svg-icons';
import { randomString } from '~/utils/string';
import GroupCollectionFilter from './GroupCollectionFilter.vue';

const filters = defineModel({
    type: Array,
    required: true,
    default: () => ([])
});

const props = defineProps({
    orgUnitId: {
        type: Number,
    },
    disabled: Boolean
});

const add = () => {
    filters.value.push({
        id: randomString(),
        attribute: '',
        operator: '',
        key: '',
        values: [],
    })
}

const removeFilter = (index) => {
    filters.value.splice(index, 1);
    if (filters.value.length === 0) {
        add();
    }
}
</script>
